export enum EstatusRetoEnum {
  SIN_RETOS_PROXIMOS = 'SIN_RETOS_PROXIMOS',
  PROXIMO_INICIAR = 'PROXIMO_INICIAR',
  RESPONDER_RONDA = 'RESPONDER_RONDA',
  ESPERAR_RONDA = 'ESPERAR_RONDA',
  EXISTE_GANADOR = 'EXISTE_GANADOR'
}



// WEBPACK FOOTER //
// ./src/dominio/estatus.reto.enum.ts